export const isPetsOnlyAllowedInVehicle = (routeCode: string): boolean => {
  if (routeCode === 'DVCA') return true
  if (routeCode === 'DVDK') return true
  if (routeCode === 'DKDV') return true
  if (routeCode === 'CADV') return true
  if (routeCode === 'DPNH') return true
  if (routeCode === 'NHDP') return true
  return false
}
